import AnimeFaves from "../components/animeList/AnimeFaves/AnimeFaves";

const MyFaves = () => {
  return <AnimeFaves />;
};

export default MyFaves;
